/** External Quick Actions for Motion Reconstruction Result —
 * CARD RIGHT OUTSIDE (sibling of `.pcv-node-inner`). Icon from Function Registry.
 *
 * TASK-00584: thin wrapper over the Admin-driven
 * `CanvasResultQuickActionRail` (source `motion_reconstruction`). */

import type { MouseEvent as ReactMouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import CanvasResultQuickActionRail from './CanvasResultQuickActionRail'

type Props = {
  onQuickCreateGenerateVideo: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  className?: string
}

export default function MotionResultWorkflowRail({
  onQuickCreateGenerateVideo,
  onMouseEnter,
  onMouseLeave,
  className,
}: Props) {
  const { t } = useTranslation('canvas')
  return (
    <CanvasResultQuickActionRail
      sourceNodeType="motion_reconstruction"
      className={className}
      railTestId="motion-result-workflow-rail"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      plainIcons
      actionHandlers={[
        {
          targetNodeType: 'generate_video',
          tooltip: t('workflowRail.generateVideo'),
          testId: 'motion-qa-generate-video',
          onClick: (e: ReactMouseEvent) => {
            e.stopPropagation()
            onQuickCreateGenerateVideo()
          },
        },
      ]}
    />
  )
}
